const DEBUGGING: boolean = process.env.NODE_ENV === 'development'

import { BaseObject, MongoObject } from './_baseClasses'
import { Account } from './Account';
import { MomentMPListing, sortOrderTypes } from './MomentMPListing';
import * as telegram from "./telegram"
import * as utils from "./utils"
import { AdvancedSearch } from '@/Moment'

export class MPListings extends BaseObject {
  // must have at least one of these specified
  public setID: number = null
  public playID: number = null
  public subeditionID: number = null
  public playerID: number = null
  public challengeID: string = null

  public sort: sortOrderTypes = null
  public moments: MomentMPListing[] = null
  public total: number = null

  private advancedSearch: AdvancedSearch = null

  // complex, class-based fields (require to be hydrated after loading from external sources like mongo or elastic)

  constructor(po?: object, setID?: number, playID?: number, subeditionID?: number, playerID?: number) {
    super()
    if (po) this.injectPlainObject(po)
    this.setID = setID
    this.playID = playID
    if (subeditionID !== null && subeditionID !== undefined) this.subeditionID = subeditionID
    this.playerID = playerID
    this.hydrate()
  }

  protected hydrate(): void {
    super.hydrate()
  }


  public isSafe(): boolean {
    return true
  }

}




(async () => {
})();
